@if (todoCardData?.image) {
  <sd-banner [media]="todoCardData.image"/>
}
<sd-tag [tagData]="tag" />
<div class="c__todo-card-content">
  @if (todoCardData?.title) {
    <p class="c__title is-body-m is-bold">
      {{ todoCardData.title }}
    </p>
  }
  @if (todoCardData?.description) {
    <div class="c__description">
      <sd-html
        innerClass="is-body-s is-medium"
        [html]="todoCardData.description"
      />
    </div>
  }
  @if (todoCardData?.link?.linkName && todoCardData?.link?.url) {
    <sd-link
      [link]="todoCardData.link"
      [isButton]="true"
      (clicked)="onClickLink(todoCardData.link)"
    >
      <span>{{todoCardData.link.linkName}}</span>
    </sd-link>
  }
</div>
